import store from '@/store/store';
import axios from 'axios';
import { config } from '../shared/app.config';

const RESOURCE_NAME = '/users';
const RESOURCE_BARMANS_NAME = '/webadmin/barmans';

export default {
  getAll () {
    return axios.get(config.webApiBase + RESOURCE_NAME);
  },
  getOne (id) {
    return axios.get(`${config.webApiBase + RESOURCE_NAME}/${id}`);
  },
  create (user) {
    const requestConfig = {
      headers: {
        // eslint-disable-next-line sonarjs/no-duplicate-string
        'Content-Type': 'multipart/form-data',
      },
    };

    return axios.post(config.webApiBase + RESOURCE_NAME, user, requestConfig);
  },
  edit (id, user) {
    const requestConfig = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    user.model = 'put';
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/${id}`, user, requestConfig);
  },
  getAllBarmansByRestaurant (restaurant_id, language) {
    if (!language) language = store.getters.getCurrentLanguage;
    return axios.get(`${config.webApiBase + RESOURCE_BARMANS_NAME}/${restaurant_id}`, {
      headers: {
        'X-localization': language,
      },
    });
  },
  getOneBarman (id, language) {
    if (!language) language = store.getters.getCurrentLanguage;
    return axios.get(`${config.webApiBase + RESOURCE_BARMANS_NAME}/one/${id}`, {
      headers: {
        'X-localization': language,
      },
    });
  },
  createBarman (barman, language) {
    if (!language) language = store.getters.getCurrentLanguage;
    const requestConfig = {
      headers: {
        'Content-Type': 'multipart/form-data',
        'X-localization': language,
      },
    };

    return axios.post(`${config.webApiBase + RESOURCE_BARMANS_NAME}/create`, barman, requestConfig);
  },
  editBarman (id, barman, language) {
    if (!language) language = store.getters.getCurrentLanguage;
    const requestConfig = {
      headers: {
        'Content-Type': 'multipart/form-data',
        'X-localization': language,
      },
    };
    barman.model = 'put';
    return axios.post(`${config.webApiBase + RESOURCE_BARMANS_NAME}/edit/${id}`, barman, requestConfig);
  },
  deleteBarman (id) {
    return axios.delete(`${config.webApiBase + RESOURCE_BARMANS_NAME}/${id}`);
  },
  activeBarman (id) {
    return axios.put(`${config.webApiBase + RESOURCE_BARMANS_NAME}/${id}/state`, { active: true });
  },
  deactiveBarman (id) {
    return axios.put(`${config.webApiBase + RESOURCE_BARMANS_NAME}/${id}/state`, { active: false });
  },
};
